import React from 'react';
import { Link } from 'react-router-dom';
import { UserPlus } from 'lucide-react';
import { appendUtm } from '../utils/utm';

/** Inline anonymous-reader nudge shown mid-article. Renders a card that
 *  tells the reader an account unlocks the rest of the story, and blurs the
 *  remainder of the article body behind it. During an open-access window the
 *  pitch is a free account, not a plan. */
const ArticleSignupNudge = ({ grace }) => {
  const open = !!grace?.active;
  return (
    <aside
      data-testid="article-signup-nudge"
      className="my-8 rounded-lg border-2 border-red-600/70 bg-gradient-to-b from-red-950/60 to-black/95 shadow-[0_0_50px_rgba(220,38,38,0.35)] p-6 sm:p-7"
    >
      <div className="flex items-center gap-2 text-red-400 text-[11px] font-black uppercase tracking-[0.3em] mb-3">
        <UserPlus className="h-3.5 w-3.5" />
        {open ? 'Free to read right now' : 'Subscribe to keep reading'}
      </div>
      <h3 className="text-white text-2xl sm:text-3xl font-black leading-tight mb-3" style={{ fontFamily: 'Georgia, serif' }}>
        {open ? 'Drop your email in to read the rest.' : 'Read this one free with an account.'}
      </h3>
      {open ? (
        <>
          <p className="text-zinc-300 text-sm sm:text-[15px] leading-relaxed mb-2">
            <strong className="text-white">Every story is free right now.</strong> One email, no card,
            no password - it joins the Outlaw list and opens the site.
          </p>
          <p className="text-yellow-200/90 text-sm mb-5">
            We believe today's reporting needs to be read and scrutinised by the masses.
          </p>
        </>
      ) : (
        <>
          <p className="text-zinc-300 text-sm sm:text-[15px] leading-relaxed mb-2">
            <strong className="text-white">A free account gets you one story a month</strong> - no
            card, just an email.
          </p>
          <p className="text-yellow-200/90 text-sm mb-5">
            Want the lot? Monthly $13, Annual $130, or Founding $249 one-off. Upgrade any time.
          </p>
        </>
      )}
      <div className="flex flex-col sm:flex-row gap-3">
        <Link
          to={appendUtm("/login")}
          data-testid="nudge-signup-cta"
          className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded bg-red-600 hover:bg-red-500 text-white font-black text-xs uppercase tracking-[0.25em] transition-colors"
        >
          <UserPlus className="h-4 w-4" />
          {open ? 'Unlock every story' : 'Read free with an account'}
        </Link>
        <Link
          to={appendUtm("/subscribe")}
          data-testid="nudge-login-link"
          className="inline-flex items-center justify-center px-5 py-3 rounded bg-zinc-900 hover:bg-zinc-800 border border-zinc-700 text-white font-bold text-xs uppercase tracking-[0.25em]"
        >
          Go unlimited
        </Link>
      </div>
    </aside>
  );
};

export default ArticleSignupNudge;
